<template>
  <div>
    <v-list-item>
      <v-list-item-icon>
        <v-icon color="primary" aria-hidden="true">mdi-account</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title v-text="displayName"></v-list-item-title>
        <v-list-item-subtitle v-if="hasName">{{ consumer.email }}</v-list-item-subtitle>
      </v-list-item-content>

      <v-dialog v-model="dialog" width="500">
        <template v-slot:activator="{ on, attrs }">
          <v-btn color="red" x-small fab outlined v-bind="attrs" v-on="on" :aria-label="`Retirer ${displayName}`">
            <v-icon aria-hidden="false" title="Retirer">$delete-fill</v-icon>
          </v-btn>
        </template>

        <v-card class="text-left">
          <v-card-title>
            <h1 class="fr-h5 mb-2">Voulez-vous retirer {{ displayName }} des convives ?</h1>
          </v-card-title>
          <v-card-text>
            <p class="mb-0">
              Ce convive ne sera plus rattaché à cette cantine. Son compte est conservé et pourra être rattaché
              ailleurs.
            </p>
          </v-card-text>
          <v-divider aria-hidden="true" role="presentation"></v-divider>
          <v-card-actions class="pa-4">
            <v-spacer></v-spacer>
            <v-btn outlined text @click="dialog = false" class="mr-2">Non, revenir en arrière</v-btn>
            <v-btn outlined color="red darken-2" text @click="remove">Oui, retirer</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-list-item>
    <v-divider aria-hidden="true" role="presentation" class="my-1"></v-divider>
  </div>
</template>

<script>
export default {
  name: "ConsumerItem",
  props: {
    consumer: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dialog: false,
    }
  },
  computed: {
    hasName() {
      return !!(this.consumer.firstName || this.consumer.lastName)
    },
    displayName() {
      return this.hasName ? `${this.consumer.firstName} ${this.consumer.lastName}`.trim() : this.consumer.email
    },
  },
  methods: {
    remove() {
      this.$emit("delete", this.consumer)
      this.dialog = false
    },
  },
}
</script>
